export function postHeaders({ needsAuthorization = false, authToken } = {}) {
    const headers = new Headers()

    headers.append(
        'Content-Type',
        'application/x-www-form-urlencoded; charset=UTF-8'
    )

    if (needsAuthorization && authToken)
        headers.append('Authorization', 'Bearer ' + authToken)

    return headers
}

function convertFormData(parameters = {}) {
    let formData = new FormData()

    if (parameters !== undefined) {
        for (let key in parameters) {
            formData.append(key, parameters[key])
        }
    }

    // Unncomment to log out params as form data
    //for (var key of formData.entries()) {
    //    console.log(key[0] + ', ' + key[1]);
    //}

    return new URLSearchParams([...formData]).toString()
}

export async function postAFetch({ endpoint, parameters = {} } = {}) {
    try {
        const response = await fetch(`${endpoint}`, {
            method: 'POST',
            body: convertFormData(parameters),
            headers: postHeaders(),
        })

        if (!response.ok) {
            console.info(response)
            throw new Error(
                `HTTP ${response.status} - There is a problem connecting to the web service.`
            )
        }

        const json = await response.json()

        return json
    } catch (e) {
        return {
            hasError: true,
            errorMessage: e,
        }
    }
}

function authPostHeades() {
    const headers = new Headers()

    headers.append(
        'Content-Type',
        'application/x-www-form-urlencoded; charset=UTF-8'
    )

    return headers
}
